module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Published by"), _c('br'), _vm._v(" Grub Street Publishing"), _c('br'), _vm._v(" 4 Rainham Close"), _c('br'), _vm._v(" London"), _c('br'), _vm._v(" SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © Grub Street 2011"), _c('br'), _vm._v(" Copyright text © Andy Saunders 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Library Cataloguing in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Saunders, Andy.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Finding the fallen : outstanding aircrew mysteries from the "), _c('br'), _vm._v("First World War to Desert Storm investigated and solved. "), _c('br'), _vm._v("1. Missing in action–Case studies. 2. Airmen–Biography. "), _c('br'), _vm._v("3. Aircraft accidents–Investigation--History–20th century. "), _c('br'), _vm._v("I. Title"), _c('br'), _vm._v("358.4'1338'0922-dc22"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ISBN-13: 9781908117106")]), _c('br'), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ePUB ISBN: 9781909166462")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, "), _c('br'), _vm._v("stored in a retrieval system, or transmitted in any form or by any "), _c('br'), _vm._v("means electronic, mechanical, photocopying, recording, or "), _c('br'), _vm._v("otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Design by Roy Platten, Eclipse, Hemel Hempstead"), _c('br'), _c('a', {
    attrs: {
      "href": "http://roy.eclipse@btopenworld.com",
      "target": "_blank"
    }
  }, [_vm._v("roy.eclipse@btopenworld.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grub Street Publishing uses only FSC"), _c('br'), _vm._v("(Forest Stewardship Council) paper for its books")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0